var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shop-steps"},_vm._l((_vm.itemsComp),function(item,index){return _c('button',{key:index,staticClass:"shop-steps__item",class:[
      {
        'shop-steps__item--active-before': (_vm.itemsComp[index + 1] || {}).id === _vm.value,
        'shop-steps__item--active': item.id === _vm.value,
        'shop-steps__item--active-after': (_vm.itemsComp[index - 1] || {}).id === _vm.value,
      },
      'shop-steps__item--status-' + item.status,
    ],attrs:{"data-id":item.id},on:{"click":() => _vm.$emit('input', item.id)}},[_c('span',{attrs:{"data-part":"icon"}},[_vm._v("\n      "+_vm._s(index + 1)+"\n    ")]),_c('span',{attrs:{"data-part":"label"}},[_vm._v(_vm._s(item.label))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }